import {parsePeriodKey} from "../../../utils/periodLabel";

/** "01.09.2026" style short date, used by the compact period cards/status panel. */
export function formatShortDate(date: Date | string | null | undefined): string {
    if (!date) return "";
    const d = typeof date === "string" ? new Date(date) : date;
    if (Number.isNaN(d.getTime())) return "";
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    return `${day}.${month}.${d.getFullYear()}`;
}

/** "01.09.2026 – 30.09.2026" style short range for a "M-YYYY"/"YYYY-M" period key. */
export function formatShortDateRange(periodKey: string | null | undefined): string {
    if (!periodKey) return "";
    const parsed = parsePeriodKey(periodKey);
    if (!parsed) return periodKey;
    const {year, month} = parsed;
    const start = new Date(year, month - 1, 1);
    const end = new Date(year, month, 0);
    return `${formatShortDate(start)} – ${formatShortDate(end)}`;
}

/** Start/end of the calendar month represented by a "M-YYYY"/"YYYY-M" period key. */
export function periodBounds(periodKey: string | null | undefined): { start: Date; end: Date } | null {
    if (!periodKey) return null;
    const parsed = parsePeriodKey(periodKey);
    if (!parsed) return null;
    const {year, month} = parsed;
    return {start: new Date(year, month - 1, 1), end: new Date(year, month, 0)};
}
